module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter-no",
    attrs: {
      "id": "ch-4"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("CHAPTER IV")])]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UT")]), _vm._v(" before the Sergeant could leave us Mr. Simmons addressed him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Are you going to leave him in the bar all night?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("There was no need for Simmons to explain what was referred to as “him.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Don’t see why not,” said Beef.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Oh, you don’t? Well, I do,” returned Simmons truculently. “It’s bad enough having a dead ’un in the house all night, without everyone who uses the bar knowing afterwards that it was there all the time. Besides, even if the chap is a murderer and suicide and that, he’s dead. And it’s not respectful to the dead to leave them in a public. And how’s young Harold to go about sweeping the place up in the morning?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("As though convinced by these arguments Beef rose. “Wot you want done with ’im then?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I’d like you to take him away altogether.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Wot, wheel ’im on my bicycle, I suppose?” suggested Beef indignantly. “I’d like to know what more you want. P’raps you expect me to take ’im to bed with me?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Well, surely there’s somewhere for him? What on earth do we pay taxes for?”")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("Beef looked stern. “It can ’ardly be expected that the authorities are to build a special ")]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("mortuary in Braxham. It’s not every day we get a suicide, nor yet a murder.”")])]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“It’s a good thing we don’t,” returned Simmons, “if they’re going to choose my hotel to do it in. Well, if you can’t take him away he better be put in the club-room at the back.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Beef nodded, and the two men approached the corpse. When they had lifted it, I went to open the door into the private part of the house, through which they could reach the club-room. But Simmons detained me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Not that way,” he said, “Mrs. Simmons is still up, and we don’t want to run into her with it. Might give her a bad turn. We must take him round outside.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("So I opened the two doors into the street, and Beef and Simmons brought their burden through.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("It was while they were carrying it down the few yards of pavement to the door through which they would pass into the Mitre yard, that I observed someone watching the whole procedure. He was immediately noticeable, for at that time of night in Braxham there was nobody about. It gave me quite a start to see him standing on the other side of the road, his hands in the pockets of his overcoat, and a black hat pulled rather far forward. He did not move when we came out, but I could see that he was watching closely. I don’t know even now quite what gave me the impression that he was a foreigner. It may have been his black hat and sallow face, or the precise cut of his clothes. But I know that afterwards when I remembered him ")]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("it was with that notion—a silent, motionless, foreign observer of our doings.")])]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In the club-room, after the two had laid the body of young Rogers on a rickety sofa, I turned to Beef.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Did you see that man?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Wot man?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“That man on the other side of the road, watching us?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“No. Just now, d’you mean?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Yes. Yes. Out there!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Beef started off as quickly as he could and Simmons and I followed him. But when we had crossed the yard and come out on to the pavement again there was no sign of the lonely watcher. Beef hurried down to the corner of the road, and looked in all directions, but no one was in sight.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“You must have been seeing things,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Oh no. He was there all right. No mistake about that. A foreign-looking chap.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Foreign-looking, eh?” said Beef.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I wonder if he was the one that came into the bar to-day when Rogers and Fairfax went out,” Simmons suggested, as he turned to lock up the club-room and the yard.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Well, anyway, we can’t do no more to-night,” said Beef. “It’s time we was all in bed. Good night, Mr. Simmons. Night, Mr. Townsend.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("And this time he managed to make his departure without further delay.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("I went up to bed not altogether pleased with what Beef and Simmons had just done, for the ")]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("club-room was directly under my own bedroom. But I was so tired that even my proximity to that corpse could not keep me awake, and it cannot have been more than ten minutes after leaving Simmons that I drifted into a deep and satisfying sleep.")])]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Waking up during the night is unusual with me, and when it happens it comes from some outside cause. I remember that I found myself staring at the square of the window, a visible yellow outline due to the street-lamp below. At first I supposed that it was morning, and then had that curious sense of being still deep in the small hours. I turned over, and determined to sleep again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("But no. At first almost negligible, then more insistently, came a sound from below me. A slight thud, I think, though I was too nearly asleep still to be certain. Then a vague rumour of movement.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Perhaps, I thought, it was morning. Perhaps someone was already astir, cleaning the rooms downstairs. I am not an early riser, and had no idea how light or dark it would be at the time the work of the house began. I groped for my watch on the table beside my bed, and looked at its luminous dial. Three o’clock. Then it could scarcely be a dream.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I listened, trying to persuade myself that it was nothing. But that was impossible. The sound was not definable, but there certainly was a sound.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("Suddenly I found myself fully awake. Here and now, if ever in my life, was my chance. ")]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("Someone had entered the club-room where the corpse of young Rogers lay. Perhaps his object was to steal something from it. Perhaps he meant to remove the body itself. Whatever his plan, he must be prevented and identified. Catching him would probably clear up the whole mystery which faced Beef. And to me had been given the opportunity of actually contributing something to the investigation.")])]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I slipped quietly from my bed, and pulled on a dressing-gown. I wondered whether to put shoes on. Being without them would give one a feeling of unprotectedness, but wearing them would make one’s approach noisy. I left them behind, slowly and silently crossed the room, and got safely to the landing. Then I started to go downstairs.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("It is not often that the mere chronicler of crime gets a thrill. His work is usually to attend, as unintelligently as possible, the dreary post-mortems, and to listen, without too much acumen, to the elucidation offered by the masters. But during those few minutes I knew all the excitements of the chase. I was about to do my own part—and an important part it would be.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("My imagination played some curious tricks. Before I opened the door I was prepared to find that the dead had risen, that young Rogers himself had left that rickety sofa and was facing me across the room. I myself had seen his livid face, and touched his stone cold flesh, and knew with absolute security that he was dead. But at three o’clock in the morning, roused ")]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("from sleep by a noise in the room where his corpse lay, I was prepared to believe anything.")])]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I had my hand on the knob of the club-room door, and began, very gently, to turn it. I did not know exactly where the switch of the electric light was, but when I began to push the door open I saw that there would be enough light from the street lamp to see across the room. Suddenly I pushed the door wide open, and looked in.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The lace curtains in front of the window were blowing into the room, and the window was wide open, but no one was in sight. I found the light switch and used it, and the strong electric light failed to reveal any more. On the sofa the corpse seemed undisturbed, and I crossed to it, and pulled back the rug. Young Rogers lay as he had done when we left him. I turned away, feeling rather disturbed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Only the open window was unusual. I went across to it and looked out on the street. There was no one in sight, and the rain blew angrily in as I stood there. I hurriedly pulled the window down, and slipped the catch across.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Someone had been in the room—there could be no doubt of it. But who? And with what object? If they had hoped to get something from the dead man’s pockets they had been disappointed, for we had emptied these ourselves in the bar. Perhaps they had had some other object in view, and I had disturbed them.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("On the whole I thought it best to telephone to Beef. He wouldn’t like being disturbed at this hour, but he ought to know what had ")]), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("happened. I went through into the sitting-room where the instrument was, and quietly, so as not to disturb any of the Simmons family, asked for his number.")])]), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I could hear the bell ringing for a long time before there was an answer. Then I heard the Sergeant’s voice, sounding blurred and resentful.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Wha’s it?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Beef—this is Townsend. Someone has just broken into the club-room of the Mitre.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“’V’you got ’im?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“No.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“’Ow d’you know, then?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I heard him from my room upstairs and came down. There was no one here, but the window which overlooks the street was open.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Did Simmons leave it open?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Of course he didn’t. You were with him when we brought the corpse in.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“That’s funny.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I was tired and irritable. “I don’t know about its being funny,” I said. “I don’t see much fun in being woken up at this time of night. What are you going to do?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Do? What ’you mean, do?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Well….”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("It wasn’t a very lucid conversation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I don’t see what I can do. You say ’e’s cleared off. What can be done?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I was about to slam down the receiver in disgust when Beef spoke again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Tell you what,” he said, as though he had just had an inspiration, “I’ll send a constable round. ’E’ll look after it. You wait there….”")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("And before I could answer, he, and not I, had replaced his receiver.")])]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The situation was absurd, but very unpleasant. I did not like to go back to bed till the constable had made his appearance, since he would probably wake the whole household if there was no one there. I felt that my old friend Beef had been given the luck of what might be another big case, and was mis-handling it badly. I was in a sour and angry mood as I waited in that bare room with the corpse of young Rogers for company.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("But it was not long before, on going to the window, I saw a young policeman striding down the road. I opened the window again, relieved to find that there was a momentary lull in the rain. I found myself looking at a young, rather handsome, fellow, with the build and features of a boxer.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Sergeant Beef sent me round, sir,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Good.” And I told him what had happened.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("He grinned pleasantly, and one could not imagine that he had just been called from his sleep to face this unpleasant night.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“That’s all right, sir,” he said. “I’ll carry on! You go back to bed.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Which, gladly enough, I did.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c74e6a78","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/008_Chapter04.vue
// module id = 81
// module chunks = 0